<template>
    <div>
        <v-autocomplete
                    class="mb-4"
                    @change="getSelectedSupplier"
                    v-model="supplierID"
                    :items="suppliers"
                    item-text="name"
                    item-value="id"
                    dense
                    color="teal"
                    filled
                    label="Select Supplier"
        ></v-autocomplete>
        <DatePickerWithMenu @date-selected="getSelectedDate" class="mt-n6 ml-n4 mr-2"></DatePickerWithMenu>
        <div>
            <v-text-field
            label="Quantity Received"
            v-model="quantity"
          ></v-text-field
        >
        </div>

        <div>
            <v-btn
            class="mt-2"
          dark
            rounded
            color="teal"
            small
            @click="recordReceivingsToReceivingsTable(product.id,supplierID,date,quantity)"
            ><v-icon left>mdi-plus</v-icon>Capture Receiving</v-btn
          >
        </div>
    </div>
</template>

<script>
import productsAndServicesJs from "@/plugins/productsAndServices"
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";

    export default {
        props:{
            newlyCreatedSupplier:{
                default:null
            },
            item:{
                default:null
            }
        },
        components:{
            DatePickerWithMenu
        },
        watch:{
            item(newProduct){
                this.setItem(newProduct)
            },
            newlyCreatedSupplier(newSupplier){
                if(newSupplier && newSupplier.id){
                    this.suppliers.unshift(newSupplier)
                    this.selectedSupplier = newSupplier
                    this.supplierID = newSupplier.id
                    this.$emit('supplier-selected',newSupplier)
                }else{
                    this.selectedSupplier = null
                    this.supplierID = null
                }
            }
        },
        data:() => ({
            product:null,
            suppliers: [],
            selectedSupplier:null,
            supplierID:null,
            quantity:1,
            date:new Date().toISOString().substring(0,10)
        }),
        async mounted(){
            this.suppliers = await this.getAllSuppliers()
            this.setItem(this.item)
        },
        methods:{
            setItem(item){
                this.product = item
            },
            async getAllSuppliers(){
                return await productsAndServicesJs.getAllSuppliers()
            },
            getSelectedSupplier(){
                this.selectedSupplier = this.suppliers.find(supplier => {
                    return supplier.id == this.supplierID
                })
                this.$emit('supplier-selected',this.selectedSupplier)
            },
            getSelectedDate(selectedDate){
                this.date = selectedDate
            },
            async recordReceivingsToReceivingsTable(productID,supplierID,date,quantity){
                this.$store.commit('setLoader',true)
                const inventoryForProduct = await productsAndServicesJs.recordReceivingsToReceivingsTable(productID,supplierID,date,quantity)
                this.$emit('receivings-added', inventoryForProduct)
                this.$store.commit('setLoader',false)
                this.$toast.success('Receiving Captured Successfully!')
            },
        }
    }
</script>